import React from "react";
import {
    SovosBox,
    SovosDialog,
    SovosDialogContent,
    SovosDialogTitle,
    SovosTypography,
} from "mosaic-react";
import { CheckCircle } from "mosaic-react-icons";

const ImportCompleteView = ({ open = false, i18n, onClose }) => (
    <SovosDialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
        <SovosDialogTitle showCloseButton onClose={onClose}>
            <span
                style={{
                    border: 0,
                    clip: "rect(0 0 0 0)",
                    height: 1,
                    margin: -1,
                    overflow: "hidden",
                    padding: 0,
                    position: "absolute",
                    whiteSpace: "nowrap",
                    width: 1,
                }}
            >
                {i18n`Import complete`}
            </span>
        </SovosDialogTitle>
        <SovosDialogContent>
            <SovosBox
                sx={{
                    alignItems: "center",
                    display: "flex",
                    flexDirection: "column",
                    px: 1,
                    py: 1,
                }}
            >
                <SovosBox sx={{ mb: 3, position: "relative" }}>
                    <SovosBox
                        sx={{
                            alignItems: "center",
                            bgcolor: "success.light",
                            borderRadius: "50%",
                            display: "flex",
                            height: 140,
                            justifyContent: "center",
                            width: 140,
                        }}
                    >
                        <SovosBox
                            sx={{
                                bgcolor: "background.paper",
                                border: "2px dashed",
                                borderColor: "primary.main",
                                borderRadius: 1.5,
                                display: "flex",
                                flexDirection: "column",
                                gap: 1,
                                height: 96,
                                justifyContent: "center",
                                p: 1.5,
                                width: 80,
                            }}
                        >
                            {[1, 2, 3, 4].map((row) => (
                                <SovosBox
                                    key={row}
                                    sx={{ bgcolor: "grey.200", borderRadius: 0.5, height: 7 }}
                                />
                            ))}
                        </SovosBox>
                    </SovosBox>
                    <SovosBox
                        sx={{
                            alignItems: "center",
                            bgcolor: "success.main",
                            borderRadius: "50%",
                            bottom: 6,
                            boxShadow: 2,
                            display: "flex",
                            height: 32,
                            justifyContent: "center",
                            position: "absolute",
                            right: 6,
                            width: 32,
                        }}
                    >
                        <CheckCircle sx={{ color: "white", fontSize: 22 }} />
                    </SovosBox>
                </SovosBox>
                <SovosTypography sx={{ mb: 1, textAlign: "center" }} variant="h5">
                    {i18n`Import complete`}
                </SovosTypography>
                <SovosTypography
                    color="text.secondary"
                    sx={{ textAlign: "center" }}
                    variant="body2"
                >
                    {i18n`Your data has been imported and audit rule will be run automatically`}
                </SovosTypography>
            </SovosBox>
        </SovosDialogContent>
    </SovosDialog>
);

export default ImportCompleteView;
